import React from "react";
const CommonToolTip = ({toolTipStyle}) => {
  return (
    <div className={`absolute ${toolTipStyle} top-full mt-2 z-20 w-[18rem] bg-white text-black text-xs p-3 rounded shadow-[0_2px_10px_rgba(0,0,0,0.5)]`}>
      <div className="absolute -top-2 right-4 w-0 h-0 border-l-8 border-r-8 border-b-8 border-l-transparent border-r-transparent border-b-white shadow-[0_2px_10px_rgba(0,0,0,0.1)]"></div>

      <p className="mb-2 font-semibold">What are Id Proofs?</p>
      <p className="mb-2">
        Id Proofs are documents such as Aadhaar Card, Degree Certificates,
        Salary Slips, and Appointment Orders.
      </p>
      <p className="mb-2 font-semibold">Why Add it?</p>
      <p className="mb-2">It helps build trust and genuinity.</p>
      <p className="mb-2 grid grid-cols-[auto,1fr] gap-x-2 text-[12px] leading-[20px] font-normal">
  <span className="font-semibold whitespace-nowrap">Note:</span>
  <span>
    Id Proofs are not visible to anyone for security reasons. However, Kalyan Matrimony will
    indicate presence of such documents as a mark of genuinity.
  </span>
</p>
    </div>
  );
};

export default CommonToolTip;
